module.exports = __webpack_public_path__ + "img/bell.ba7a9d5b.svg";